import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation, useParams } from 'react-router-dom';
import { LanguageSwitcher } from './language-switcher';
import { SCORM_DOWNLOAD_PRICING } from '../../lib/features';

const NAV = [
  ['converter', 'site.header.converter'],
  ['ai-builder', 'site.header.ai'],
  ['scorm-versions', 'site.header.scorm'],
  ['pricing', 'site.header.pricing'],
  ['faq', 'site.header.faq']
] as const;

export function Header() {
  const { t, i18n } = useTranslation();
  const { lang } = useParams<{ lang: string }>();
  const currentLang = lang || i18n.language || 'en';
  const home = `/${currentLang}/`;
  const location = useLocation();
  const onHome = location.pathname.replace(/\/$/, '') === `/${currentLang}`;
  const [menuOpen, setMenuOpen] = useState(false);
  // Until the AI course builder opens, the header action leads to the waitlist form.
  const waitlistHref = `${home}#waitlist`;

  useEffect(() => {
    if (!menuOpen) return;
    const onKey = (event: KeyboardEvent) => { if (event.key === 'Escape') setMenuOpen(false); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [menuOpen]);

  const links = NAV.filter(([id]) => SCORM_DOWNLOAD_PRICING || id !== 'pricing').map(([id, key], index) => (
    <a key={id} href={`${home}#${id}`} className={onHome && index === 0 ? 'nav-current' : undefined} onClick={() => setMenuOpen(false)}>
      {t(key)}
    </a>
  ));

  return (
    <>
      <a className="skip" href="#main">{t('site.header.skip')}</a>
      <header className="site-header">
        <div className="wrap header-inner">
          <Link className="brand" to={home} aria-label={t('site.header.home')}>
            <img src="/brand/scormate-logo-color-480.png" alt="" width="480" height="127" />
          </Link>
          <nav className="desktop-nav" aria-label={t('site.header.mainNav')}>{links}</nav>
          <div className="header-actions">
            <LanguageSwitcher />
            <a className="button secondary compact" href={waitlistHref}>{t('site.header.earlyAccess')}</a>
            <button
              type="button"
              className="icon-button mobile-menu-button"
              aria-label={t(menuOpen ? 'site.header.closeMenu' : 'site.header.openMenu')}
              aria-expanded={menuOpen}
              aria-controls="mobile-nav"
              onClick={() => setMenuOpen((open) => !open)}
            >
              <img src="/site/icons/Menu.svg" alt="" />
            </button>
          </div>
        </div>
        <nav id="mobile-nav" className="mobile-nav" aria-label={t('site.header.mobileNav')} hidden={!menuOpen}>
          {links}
          <a className="button secondary" href={waitlistHref} onClick={() => setMenuOpen(false)}>{t('site.header.earlyAccess')}</a>
        </nav>
      </header>
    </>
  );
}
